import "@maersk-global/mds-design-tokens/maersk/light/css/design-tokens-px.css";
import "@maersk-global/mds-foundations/css/foundations.css";
import "@maersk-global/fonts/maeu/fonts.css";
import "./theme-dark.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./auth";
import { ThemeProvider } from "./context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
reportWebVitals();
